import React,{useState,useEffect, Children} from 'react';

import API from '../../API'
import { Wrapper,Image, Content,Data, StyledLink} from "./Thumb.styles";
import { Link } from "react-router-dom";
import Knoppie from '../Knoppie';
import useAuth from '../../hooks/useAuth';


const Thumb = ({ image, id,employeeid, children ,name,area,item,phone,playercount,points ,clickable,root,from}) => {
    
    
   
    
            

return(

    <div>
        
        {clickable && root==="Club"?(
            <Content>
                
            <StyledLink to={`/${id}`} state={{itemid: id}}>
                <Wrapper>
                <Content>{name}</Content>
                <Content>{area}</Content>
                <Content>{phone}</Content>
                <Content>{playercount}</Content>
                <Content>{points}</Content>
                
                </Wrapper>
                
            </StyledLink>

            </Content>
        ):
        (clickable && root!=="Club" ?(
            <Wrapper id={employeeid}>
            
                
                <StyledLink 
                    
                    to={root==="employee"?`../employee/${employeeid}`:
                        root==="stockitem"?`../stockitem/${id}`:
                        root ==="warehouse"?`../warehouse/${id}`:
                        root ==="file"?`../pdfview/${id}/""/""`:
                        root ==="ioditem"?`../Injury/${id}`:
                        root ==="User"? `../User/${id}` :
                        `../employee/${employeeid}`} 
                    state={{
                        itemid: id,
                        employeeid,
                        from:from 
                    }}
                    preventScrollReset
                >
                    <Image src={image}></Image>
                    
                    <Data>
                        <div>{name}</div>
                        <div>{area}</div>

                    </Data>

                
                    

                  </StyledLink>
                    <Content>
                   {children}

                    </Content>

            
           
            </Wrapper>
        )
         : root === "CLub"?(
        <Wrapper>
                    <Content>{name}</Content>
                    <Content>{area}</Content>
                    <Content>{phone}</Content>
                    <Content>{playercount}</Content>
                    <Content>Points</Content>
                    <Content>{employeeid}</Content>
       </Wrapper>
         ):
        
         (
            <Wrapper>
                <Content>

                <Image src={image}></Image>
                    <Content>{name}</Content>
                    <Content>{area}</Content>
                   
                    

                </Content>
                    <Content>{children}</Content>
            </Wrapper>
         )
        
        )}

        
    </div>
)


    };


    
export default Thumb;
